import { configureStore } from '@reduxjs/toolkit';
import platformReducer, { setAccount, setUser } from './features/platformSlice';
import alertReducer from './features/alertSlice';

export const store = configureStore({
  reducer: {
    platform: platformReducer,
    alerts: alertReducer,
  },
  middleware: gDM => gDM({ serializableCheck: false }),
});

export default store;

const restoreFromStorage = async () => {
  try {

    const token = localStorage.getItem('auth_token');
    const userData = localStorage.getItem('userData');

    if (token && userData) {
      const user = JSON.parse(userData);
      store.dispatch(setUser(user));

      const accountData = localStorage.getItem('accountData');
      if (accountData) {
        store.dispatch(setAccount(JSON.parse(accountData)));
      }
    }
    const chartType = localStorage.getItem('chartType');
    if (chartType) {
      // store.dispatch(setChartType(chartType));
    }
  } catch (error) {
    console.error('Failed to restore auth state from storage:', error);
  }
};

restoreFromStorage();

